/** Hidden input only bots fill in. Not in any form schema, so it never reaches stored `data`. */
export const FORM_HONEYPOT_FIELD = "_pb_hp";

export function isHoneypotTripped(data: Record<string, unknown>): boolean {
	const value = data[FORM_HONEYPOT_FIELD];
	return typeof value === "string" ? value.trim() !== "" : value != null;
}

/** Copy of the posted payload without the honeypot key, for `rawPayload`. */
export function withoutHoneypot(
	data: Record<string, unknown>
): Record<string, unknown> {
	const { [FORM_HONEYPOT_FIELD]: _omit, ...rest } = data;
	return rest;
}
